import { scrollTo } from '../lib/util';
import { duration } from '../lib/const';
const BackToTop = {}

BackToTop.init = function(parentElm, shouldScrollToTopOfWidget){
    var scrollToTop = function(){
        const controlsOffsetY = shouldScrollToTopOfWidget  
                                ? window.pageYOffset + parentElm.getBoundingClientRect().top - 210
                                : 0;
        scrollTo(document.scrollingElement, controlsOffsetY, duration);
    }

    const bttButton = parentElm.querySelector('[data-js-back-to-top]');
    bttButton.addEventListener('click', scrollToTop);
}

export default BackToTop;